import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: { ...theme.containerGrid, marginBottom: 0 },
  iOS: {
    /*position: 'absolute',*/
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  Android: {
    height: '100vh',
  },
  restToPay: { margin: '1.5rem 0 0 0' },
  payPlusForm: {
    margin: '0 1.5rem',
    '& div.slabel, & div.payment-secure': {
      background: '#f8f5f9',
    },
    paddingBottom: '10rem',
  },
  payPlusFormIOS: {
    margin: '0 1.5rem',
    paddingBottom: '3.5rem',
    '& div.slabel, & div.payment-secure': {
      background: '#f8f5f9',
      height: '35px',
    },
  },
  iOSMargin: {
    paddingBottom: '6.2rem',
  },
  subHeader: {
    margin: '1rem',
  },
  important: {
    fontWeight: 'bold',
  },
  title: { ...theme.title, fontSize: '55px' },
  subTitleSuccessPaid: theme.title,
  subTitle: theme.subTitle,
  subTitle2: { ...theme.subTitle2, marginTop: '1rem' },
  containerButtonActions: {
    background: 'white',
    padding: '1.7rem 0',
    position: 'fixed',
    bottom: '0',
    borderRadius: '30px 30px 0 0',
    boxShadow: '0 -2px 20px rgba(0, 0, 0, 0.1)',
  },
  error: theme.containerError,
  visible: {
    visibility: 'visible',
    // marginBottom: '2.5rem',
  },
  hide: {
    visibility: 'hidden',
    // marginBottom: '2.5rem',
  },
  disabled: { pointerEvents: 'none' },
  topPayPlus: {
    position: 'absolute',
    top: 0,
    background: '#f8f5f9',
    right: 0,
    margin: '10px',
  },
  iOSFullheight: {
    height: 'calc(100vh - 57px)',
    //paddingBottom: '10rem',
  },
  errorTpeRoot: {
    backgroundColor: 'rgba(171, 171, 171, 0.1)',
    height: '100vh',
    margin: '.3rem 0 1rem 0',
  },
  errorTpeContent: { ...theme.title, fontSize: '30px', marginBottom: '1rem' },
  text: {
    margin: '15vh 1vh',
    textAlign: 'center',
  },
  errorTpelabel: {
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
  },
  buttonPay: {
    border: 'none',
    outline: 'none',
    borderRadius: '10px',
    textTransform: 'inherit',
    minHeight: '62px',
    margin: '.6rem 0',
    boxShadow: '0 3px 15px rgba(0, 0, 0, 0.1)',
    minWidth: null,
    width: '100%',
    backgroundColor: '#5ac8f5',
    color: '#fff',
    fontSize: '18px',
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
  },
  minHeight: {
    minHeight: '350px',
  },
}));

export default useStyles;
